<template lang="pug">
section#team-group.bg-cover.bg-fixed
section.bg-white.invisible(v-scroll add-class="animated fadeInUp" remove-class="invisible")
  .sm-container.text-center
    h1.text-uppercase {{'ABOUT_PEOPLE_HEAD' | wordDict}}
    p.section_desc {{'ABOUT_PEOPLE_DESC' | wordDict}}

second-menu(:selectorid="'tab-selector-teams'",
            :tabs="tabs",
            :synctab.sync="selectedSubTab",
            :isshadow="false")
section.visible-xs
  h2.text-uppercase.text-center {{selectedSubTab}}
section#people(flex="row justify-start wrap")
  .grid(v-for="team in showTeam(teams)")
    item(
      ':link'="team | teamDetailUrl selectedSubTab | slug"
      ':title'="team.name | multilang"
      ':desc'="team.title | multilang"
      ':full-text'='true',
      ':align-bottom'='true',
      ':image'="team.thumbnail_image | resource"
    )
</template>

<script>
import axios from 'axios'
import { toJson } from './../../util'
import Item from './../item.vue'
import FilterList from './../filter-list.vue'
import VideoImageSlider from '../video_image_slider.vue'
import Uri from 'urijs'
import SecondMenu from '../second-menu.vue'

const categories = [
  {
    id: 'partner',
    en: 'partner',
    zh_hant: '伙伴'
  },
  {
    id: 'management',
    en: 'management',
    zh_hant: '管理'
  },
  {
    id: 'investment',
    en: 'investment',
    zh_hant: '投資'
  }
]

export default {
  data () {
    return {
      selectedSubTab: Uri().segment(2), //navigation within team
      selectedTab: 'team', //navigation between about pages
      teams: [],
      tabs: _.map(categories, (val) => ({title: val[window.lang], id: val.id})),
    }
  },
  computed: {},
  created () {
    axios.get('/api/people', {
      params: {
        hits: 1000
      }
    })
    .then((response) => {
      if (_.has(response.data, 'results')) {
        const results = response.data.results
        this.teams = response.data.results
      }
    })
  },
  ready () {
    if (!this.selectedSubTab) {
      this.selectedSubTab = 'partner';
    }
    if (_.has(this.$route.query, 'back')) {
      console.log('have back');
      this.scrollToPeople();
    }
  },
  attached () {},
  watch: {
    selectedSubTab(val) {
      this.$router.go(`/about/team/${val}`)
      // this.scrollToPeople();
    },
  },
  methods : {
    showTeam(teams) {
      return teams.filter((person) => person.category == _s.capitalize(this.selectedSubTab))
    },
    scrollToPeople() {
      this.$nextTick(function() {
        window.scrollTo(0, $('#people').offset().top-450)
      });
    }
  },
  components: {
    item: Item,
    VideoImageSlider,
    SecondMenu,
  }
}
</script>

<style lang="scss">
#people {

  padding-top: 0;
  .item {
    margin: 0;
  }
  .item-text {
    &.full-height {
      h5 {
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 5px;
      }
      p {
        letter-spacing: 3px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "global";
#team-group {
  height: 800px;
  background-image: url("./images/Full_1_About_Team.jpg");
  background-position: top;
}
.sm-container {
  margin-top: 50px;
}
.team-list {
  padding-bottom: 80px;
}
.grid {
  width: 33.333333%;
  @media(max-width: $grid-float-breakpoint-max) {
    width: 100%;
    &:first-child {
      border-top: 1px solid $gray-lighter ;
    }
    border-bottom: 1px solid $gray-lighter ;
  }
}

@media(max-width: $grid-float-breakpoint-max) {
  h1 {
    font-size: 18px;
    letter-spacing: 0;
  }
  h2 {
    font-size: 18px;
    letter-spacing: 0;
    margin: 16px auto;
  }
  section {
    border-bottom: 1px solid #eee;
    padding-top: 12px;
    padding-bottom: 12px;
    .sm-container {
      margin-top: 0;
      .section_desc {
        margin-top: 28px;
        margin-bottom: 16px;
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
  #team-group {
    // height: 166px;
    height: 0;
    padding-bottom: 42%;
    background-size: cover;
    background-attachment: local;
  }
  #people {
    padding-bottom: 0;
  }
  #company-list-companies {
    padding-top: 58px;
  }
}
</style>

<style lang="scss">
@import "global";
@media(max-width: $grid-float-breakpoint-max) {
  #tab-selector-teams{
    left: 50%;
    right: 0;
    width: 50%;
    .tab-select-icon {
      right: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// teams.vue?cd2630e4